const dictionary = {
    ADMIN: 'مدیر',
    STAFF: 'کارمند',
    BUYER: 'کاربر عادی'
}

function normalizer() {
}

function prepareForEdit(data) {
    // tags 
    data.tag = data.tag.map(t => {return {key: t.id, label: t.title}});
    return data;
}

function findRoleTitle(roles, roleId) {
    const role = roles.find(r => r.id === roleId);
    if (role) {
        return dictionary[role.title];
    }
    return 'نامشخص';
}

function translateRoles(roles) {
    return roles.map(r => Object.assign({}, r, {title: dictionary[r.title] || r.title}));
}

export {
    normalizer,
    prepareForEdit,
    findRoleTitle,
    translateRoles
}


// WEBPACK FOOTER //
// ./src/containers/Users/pipeline.js